/* Newsletter sign-up — progressive enhancement of the native Shopify customer form.
   Validates the email in the browser and shows an inline message; a valid email is always
   submitted natively (no preventDefault), so the form also works without JavaScript. */
(function () {
  'use strict';
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function setup(form) {
    var input = form.querySelector('input[type="email"]');
    var msg = form.querySelector('[data-news-msg]');
    if (!input || !msg) return;
    var message = form.getAttribute('data-invalid-message') || '';

    form.addEventListener('submit', function (e) {
      var ok = EMAIL_RE.test(input.value.trim());
      if (ok) return;
      e.preventDefault();
      msg.classList.add('is-error');
      msg.textContent = message;
      input.setAttribute('aria-invalid', 'true');
      input.focus();
    });

    input.addEventListener('input', function () {
      if (input.getAttribute('aria-invalid') !== 'true') return;
      if (EMAIL_RE.test(input.value.trim())) {
        input.setAttribute('aria-invalid', 'false');
        msg.classList.remove('is-error');
        msg.textContent = '';
      }
    });
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var forms = scope.querySelectorAll('form[data-news]');
    for (var i = 0; i < forms.length; i++) {
      if (window.ZC && window.ZC.once) { if (!window.ZC.once(forms[i], 'news')) continue; }
      else if (forms[i].__zcNews) continue; else forms[i].__zcNews = true;
      setup(forms[i]);
    }
  }

  if (window.ZC && window.ZC.mount) window.ZC.mount(init);
  else if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
})();
